var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',{class:{ 'primary': _vm.darkHeader, 'white--text': _vm.darkHeader }},[_vm._t("header"),_c('v-spacer'),_vm._t("actions")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }